import { ImageSlice } from '@monofront/slice-machine/prismicio-types';
import SingleFullWidth from './SingleFullWidth';
import WithMargins from './WithMargins';

const Image = (props: ImageSlice) => {
  if (props.variation === 'default') {
    return <SingleFullWidth {...props} />;
  }

  if (props.variation === 'withMargins') {
    return <WithMargins {...props} />;
  }

  // @ts-expect-error safeguard missing Prismic definition
  throw new Error(`Unknown variation for Image: ${props.variation}`);
};

export default Image;
